import React from "react";
import { Button, Modal, Stack, useTheme } from "@mui/material";

import { BG_COLORS } from "../../constants";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { selectAmazonAccount } from "../../features/user/user.selector";
import { setAmazonAccount } from "../../features/user/user.slice";
import {
  openAmazonConsent,
  SellerCentralConnect,
} from "../SellerCentralConnect";
// import { selectIsFreePlan } from "../../features/pricingPlans/pricingPlans.selector";

export const SellerCentralModal: React.FC = () => {
  const dispatch = useAppDispatch();
  const { isValid, shouldShowModal } = useAppSelector(selectAmazonAccount);
  // const isFreePlan = useAppSelector(selectIsFreePlan);
  const theme = useTheme();
  const zIndex = Math.max(...Object.values(theme.zIndex)) + 1;

  const handleConnect = () => {
    openAmazonConsent();
    dispatch(setAmazonAccount({ shouldShowModal: false }));
  };

  const handleClose = () => {
    dispatch(setAmazonAccount({ shouldShowModal: false }));
  };

  return (
    <Modal
      // open={!isValid && shouldShowModal && isFreePlan}
      open={!isValid && shouldShowModal}
      sx={{ zIndex }}
      tabIndex={-1}
      disableAutoFocus
    >
      <Stack
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "700px",
          maxWidth: "100%",
          bgcolor: BG_COLORS.default,
          border: "none",
          p: 6,
          borderRadius: 1,
        }}
      >
        <SellerCentralConnect
          onConnect={handleConnect}
          secondaryAction={
            <Button
              variant="outlined"
              size="large"
              sx={{ mt: 1 }}
              onClick={handleClose}
            >
              Remind me later
            </Button>
          }
        />
      </Stack>
    </Modal>
  );
};
